import indria from './assets/w-sahabat1.jpg';
import tri from './assets/user.png';
import intan from './assets/w-intan.jpg';
import fitriana from './assets/w-fitriana.jpg';
import niken from './assets/w-niken.jpg';
import mefa from './assets/w-mefa.jpg';
import yasinta from './assets/w-yasinta.jpg';
import nurul from './assets/w-nurul.jpg';
import arum from './assets/w-arum.jpg';
import david from './assets/w-david.jpg';
// import mugik from './assets/w-mugik.jpg';
// import anang from './assets/w-anang.jpg';
// import candra from './assets/w-candra.jpg';
// import iruka from './assets/w-iruka.jpg';
// import imam from './assets/w-imam.jpg';
// import roro from './assets/w-roro.jpg';
// import puspa from './assets/w-puspa.jpg';
// import purwanti from './assets/w-purwanti.jpg';
// import yani from './assets/w-yani.jpg';
// import rudi from './assets/w-rudi.jpg';


export const wishlist = [
  {
    name: 'Indria',
    infoName: 'Teman SMA Kita Berdua',
    description: `"Akhirnya hari bahagia ini datang juga
    Selamat kepada sahabat tercintaku saat ini engkau telah menempuh kehidupan baru dengan pendamping hidup yang telah Allah pilih untukmu.
    Semoga rahmat dan kasih sayang Allah selalu menyertai kalian,menjadi keluarga yang sakinah mawaddah dan warahmah
    Selamat berbahagia sahabat tercintaku.
    Bârakallâhu laka wa bâraka ‘alaika wa jama‘a bainakumâ fî khairin.   
    'Semoga Allah memberkahimu dalam suka dan duka dan semoga Allah mengumpulkan kalian berdua di dalam kebaikan.'"`,
    image: indria,
  },
    {
    name: 'Tri Sudarmanto',
    infoName: 'Teman SMA Kita Berdua',
    description: `"'Semoga Allah SWT menyempurnakan kebahagiaan kalian dan menjadikan pernikahan kalian sebagai ibadah kepada-Nya.'
    Baarakallahu laka wa baarakaa alaika wa jamaa bainakumaa fii khoirin. Semoga Allah memberkahimu dalam segala hal dan mempersatukan kamu berdua dalam kebaikan.."`,
    image: tri,
  },
  {
    name: 'Intan Ilsa',
    infoName: 'Teman Kuliah Mira',
    description: `"Selamat menempuh kehidupan baru, semangat memulai awal baru dengan pasangan & 
    semoga berkat melimpah untuk kehidupan rumah tangga kalian berdua
    Wishing you a lifetime happiness together ❤️"`,
    image: intan,
  },
  {
    name: 'Rizky Fitriana Rosalin',
    infoName: 'Sahabat Kampus Unika Soegijapranata',
    description: `"Barakallahu laka wabaraka ‘alaika wajama’a bainakuma fi khairin.”
    (Semoga Allah memberi keberkahan kepadamu dan atasmu serta mengumpulkan kamu berdua dalam kebaikan.)
    Sakinah mawadah warahmah teruntuk Bu Mira & Suami`,
    image: fitriana,
  },
  {
    name: 'Bu Niken',
    infoName: 'Rekan Kerja Mira',
    description: `"Ketika kau meminta Tuhan utk mempertemukan pasangan hdpmu dan Tuhan telah mengabulkannya adlh sungguh sesuatu yg sangat luar biasa..
    Kau harus menjaganya dan mencintainya sepanjang hdpmu 
    Dan itu hrs kau lakukan sbg bentuk tgg jawab kpd Tuhan dan dirimu sendiri
    Krn dia telah hadir utk melengkapi kehdpnmu
    Terimalah dia dg segala kelebihan dan kekurangannya
    Tuhan tdk pernah terlalu cepat atau terlambat dlm mmberi sesuatu yg indah bagimu
    Selamat berbahagia dlm menempuh hidup baru yg penuh makna
    Tuhan selalu mmberkati hidupmu
    Doaku selalu menyertaimu 🌹🌹🌹"`,
    image: niken,
  },
  {
    name: 'Faisal & Mei',
    infoName: 'Rekan Kerja Mira',
    description: `"Selamat menempuh hidup baru mbak mira dan suami 🖤
    Hari perayaan pernikahan hanya akan berlangsung sesaat, 
    tapi semoga cintamu dan cintanya akan tetap tumbuh. Semoga jadi pasangan yang sempurna, 
    Selamat menempuh hidup baru dan menjadi keluarga yang saqinah mawaddah serta warrohmah."`,
    image: mefa,
  },
  {
    name: 'Yasinta Arwin',
    infoName: 'Teman Kuliah Mipa',
    description: `"Aku merasa sangat bahagia, akhirnya kau bertemu dengan belahan jiwamu ..di hari bahagia yg selama ini kau tunggu aku hanya bisa mendoakan semoga ini menjadi awal dari  hidup barumu yg indah.. hidup yg lebih berbahagia dan penuh warna.. semoga selalu rukun dan saling mencinta..langgeng sampai ke surga...amin.."`,
    image: yasinta,
  },
  {
    name: 'Khomsatun Nurul Khoirunn',
    infoName: 'Teman Mira',
    description: `"Selamat menempuh hidup baru ya,selamat menjalani ibadah yang penuh rohmat dan berkah...
    Aku mendo'akan ,semoga keluarga barumu selalu dalam perlindungan Allah SWT...
    Menjadi keluarga yang sakinah,mawadah,warohmah,dan selalu dalam rihmat dan keberkahan dari Allah SWT...Aamiin"`,
    image: nurul,
  },
  {
    name: 'Proboningrum',
    infoName: 'Saudara Kandung Mira',
    description: `"Akhirnya ku menemukanmu, 
    Saat hati ini mulai merapuh
    Akhirnya ku menemukanmu
    Saat raga ini ingin berlabuh
    Ku berharap engkau lah
    Jawaban segala risau hatiku
    Dan biarkan diriku
    Mencintaimu hingga ujung usiaku 🎶🎶
    Happy wedding sist.., selalu ada pelangi setelah hujan, selalu ada keindahan setelah ada kesedihan."`,
    image: arum,
  },
  {
    name: 'Pak David',
    infoName: 'Rekan Kerja Mira',
    description: `Selamat Menempuh Hidup Baru. Semoga Allah menyempurnakan Kebahagiaan dan Ibadah Bp dan Ibu 
    serta memberikan Petunjuk dalam Hidup Berumah Tangga yang sesuai dengan Ajaran Agama.`,
    image: david,
  },
  // {
  //   name: 'Kurnia Mahardhika K & Istri',
  //   infoName: 'Sahabat SMA Mei',
  //   description: `Selamat menempuh hidup baru untuk Mei dan Faisal, sejatinya pernikahan adalah lembaran baru kehidupan, kebahagiaan, kebersamaan, dan hal-hal baik lainnya yang menyertai. Semoga cinta kalian terus bertumbuh dan semakin menguat setiap harinya. Dan Allah SWT menjadikan kalian menjadi keluarga yang Sakinah, Mawaddah, Warahmah. Aamiin Aamiin Ya Rabbal Alaamiin`,
  //   image: kurnia,
  // },
  // {
  //   name: 'Mugiyono',
  //   infoName: 'Sahabat SMA Mei',
  //   description: `Selamat buat Mei dan Faisal, semoga diberi kesehatan yang lebih baik, rejeki yang lebih baik, dan jangan lupa kabar kabar kalo sudah diberi momongan baru ☺️`,
  //   image: mugik,
  // },
  // {
  //   name: 'Anang Satrio Nugroho',
  //   infoName: 'Sahabat SMA Mei',
  //   description: `Selamat menempuh hidup baru Mei, semoga menjadi keluarga yang sakinah, mawadah warohmah, dilimpahkan rezeki nya dan selalu memberikan kebahagiaan bagi keluarga dan orang orang sekitar aamiin`,
  //   image: anang,
  // },
  // {
  //   name: 'Candra Dwi Prasetyo',
  //   infoName: 'Sahabat SMA Mei',
  //   description: `Happy wedding ya Mei dan Faisal. Barakallahu lakuma wa baraka a'laikuma wa jama'a bainakuma fii khoir`,
  //   image: candra,
  // },
  // {
  //   name: 'Solekhah Nur Hayati Widodo',
  //   infoName: 'Sahabat Teater Faisal',
  //   description: `"Turut berbahagia, Semoga cita-cita berdua segera terwujud.
  //   Semoga diberkahi, diberi kekuatan serta kebahagiaan selalu untuk keluarga barunya dan menjadi tabungan surga.
  //   Selamat menempuh hidup baru..."`,
  //   image: iruka,
  // },
  // {
  //   name: 'Imam Mahfudz',
  //   infoName: 'Sahabat Teater Faisal',
  //   description: `"Selamat memasuki fase hidup baru. Berkah, bahagia, dan lhaass lheess~"`,
  //   image: imam,
  // },
  // {
  //   name: 'Diajeng roro',
  //   infoName: 'Sahabat Teater Faisal',
  //   description: `"Happy wedding dek ical dan Mei ...Lembaran baru dimulai, tantangan dan rintangan pastinya selalu menyertai,
  //   ingat hari ini,dimana kamu mengucap kalimat sakral di altar Tuhan ketika kamu di puncak menyerah dari segala masalah. 
  //   Doaku semoga kalian selalu disertai kebahagiaan dan keberkahan dalam mengarungi bahtera rumah tangga, 
  //   Sakinah, Mawaddah dan Warohmah, aaamiin"`,
  //   image: roro,
  // },
  // {
  //   name: 'Dyah puspa & Keluarga',
  //   infoName: 'Saudara Faisal',
  //   description: `"Selamat atas pernikahan om Sal n onty Mei.
  //   Selamat mengarungi bahtera rumah tangga, semangat untuk bekerja sama dalam suka dan duka. 
  //   Semoga Allah SWT berikan perlindungan, kesehatan, dan kelimpahan rezeki yang barokah. 
  //   Sakinah, Mawaddah, wa Rahmah. Aamiin"`,
  //   image: puspa,
  // },
  // {
  //   name: 'Purwanti & Keluarga',
  //   infoName: 'Saudara Faisal',
  //   description: `"Doa terbaik kagem panjenengan sedoyo.. Mugi2 tansah pinaringan kesarasan,umur lan rizki ingkang berkah barokah.
  //   diparingi kelancaran kagem acaranipun om sal kalian nte mei, pangapurane mboten saged biantu nopo2 naming saged urun dungo saking mriki....
  //   Mugi2 Allah ijabahi. Aamiin."`,
  //   image: purwanti,
  // },
  // {
  //   name: 'Urip Tri Handayani',
  //   infoName: 'Rekan Kerja Faisal, PT Toko Besi Tan',
  //   description: `Selamat hari bahagia. Jadikanlah pernikahan ini sebagai ibadah sepanjang hidupmu. Semoga Allah SWT selalu memberi kemudahan dalam perjalanan cinta kalian dan menjadikan kalian pribadi yang semakin taqwa untuk menggapai ridho-Nya.`,
  //   image: yani,
  // },
  // {
  //   name: 'Ahmad Rudi Irawan',
  //   infoName: 'Sahabat kuliah Faisal',
  //   description: `Selamat menempuh hidup baru untuk mas Faisal dan mba Mei, barakallahu lakum wa baraka alaikum. semoga jadi keluarga yang sakinah, mawaddah dan warahmah 🤲`,
  //   image: rudi,
  // },
];
